import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionService } from '@com-delta-idp/mnx-oauth';
import { EndpointKeys, Libraries } from '@com-delta-idp/mnx-skymiles-shared';
import {
  ApiBuilder,
  AppConfigService,
  CustomError,
  handleError,
  HttpRequestMethods,
  IDP_APPS,
  logCustomError
} from '@com-delta-idp/mnx-utils';
import { Observable, of, throwError } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  commonHeaderInfo,
  SKYCLUB_CUSTOM_HEADER_KEY,
  SkyClubRequest,
  SkyClubResponse
} from '../../models';
import { CommonRequest } from '../../models/api/tracker.interfaces';

@Injectable({
  providedIn: 'root'
})
export class SkyClubTrackerService {
  constructor(
    private http: HttpClient,
    private appConfig: AppConfigService,
    private session: SessionService
  ) {}

  getSkyClubTrackerVisit = (
    commonRequest: CommonRequest,
    payload: SkyClubRequest
  ): Observable<SkyClubResponse | undefined> => {
    commonHeaderInfo['X-Delta_LoungeAmexVisitReport_SI'] =
      SKYCLUB_CUSTOM_HEADER_KEY;
    commonHeaderInfo['Authorization'] =
      'Bearer ' + this.session.token.access_token;
    commonHeaderInfo['localDateTime'] = this.getCurrentLocalDateTime();
    if (payload) {
      return new ApiBuilder<SkyClubRequest, SkyClubResponse>(
        this.http,
        this.appConfig
      )
        .app(IDP_APPS.SKYMILES)
        .endpointKey(EndpointKeys['SKYMILES_API_SKYCLUB_TRACKER'])
        .method(HttpRequestMethods['POST'])
        .payload(payload)
        .httpHeaders(commonHeaderInfo)
        .timeOut(commonRequest.timeout)
        .retries(commonRequest.retry)
        .errorHandler(handleError.bind(this))
        .library(Libraries.OVERVIEW)
        .withCredentials(true)
        .create()
        .pipe(
          map((response: SkyClubResponse | CustomError) => {
            return this.existCustomError(response);
          })
        );
    }
    return of(undefined);
  };

  existCustomError(response: SkyClubResponse | CustomError): SkyClubResponse {
    if ('errorResponse' in response) {
      logCustomError(
        response.errorResponse,
        IDP_APPS.SKYMILES,
        Libraries.OVERVIEW,
        EndpointKeys.SKYMILES_API_SKYCLUB_TRACKER
      );
      throw throwError(response);
    }
    return response;
  }

  getCurrentLocalDateTime() {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    return `${year}${month}${day}${hours}${minutes}${seconds}`;
  }
}
